import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144')
];

export const server_loads = [];

export const dictionary = {
		"/(auth-required)/agreements-and-policies": [62,[2]],
		"/auth/callback": [141],
		"/(auth-required)/billing/[org_namespace]": [63,[2,7]],
		"/(auth-required)/billing/[org_namespace]/payment": [64,[2,7]],
		"/(auth-required)/dashboard": [65,[2,8],[,9]],
		"/(auth-required)/dashboard/[dashboard_id]": [66,[2,8,10],[,9]],
		"/(auth-required)/datasets": [76,[2,14]],
		"/(auth-required)/datasets/[dataset_id]": [77,[2,14]],
		"/(auth-required)/datasets/[dataset_id]/evaluations": [78,[2,14]],
		"/(auth-required)/datasets/[dataset_id]/train": [79,[2,14]],
		"/(auth-required)/data/all": [67,[2,11]],
		"/(auth-required)/data/datasets": [68,[2,11,12]],
		"/(auth-required)/data/models": [69,[2,11,13]],
		"/(auth-required)/data/pipelines": [70,[2,11]],
		"/(auth-required)/data/pipelines/new": [72,[2,11]],
		"/(auth-required)/data/pipelines/[pipeline_id]": [71,[2,11]],
		"/(auth-required)/data/query": [73,[2,11]],
		"/(auth-required)/data/sequences": [74,[2,11]],
		"/(auth-required)/data/sequences/[id]": [75,[2,11]],
		"/(auth-required)/error": [80,[2]],
		"/(auth-required)/fleet": [81,[2,15],[,16]],
		"/(auth-required)/fleet/(locations)/locations": [84,[2,15],[,16,17]],
		"/(auth-required)/fleet/(locations)/location/[location_id]": [82,[2,15,,18],[,16,17]],
		"/(auth-required)/fleet/(locations)/location/[location_id]/slam": [83,[2,15,,18],[,16,17]],
		"/(auth-required)/fleet/machines": [85,[2,15],[,16,19]],
		"/(auth-required)/fleet/modules": [86,[2,15,20],[,16]],
		"/(auth-required)/fleet/modules/in-use": [87,[2,15,20],[,16]],
		"/(auth-required)/fleet/modules/in-use/[org_namespace_or_id]/[module_name]": [88,[2,15,20],[,16]],
		"/(auth-required)/(fragments)/fragments": [59,[2,6]],
		"/(auth-required)/(fragments)/fragments/in-use": [60,[2,6]],
		"/(auth-required)/(fragments)/fragments/in-use/[fragment_id]": [61,[2,6]],
		"/(auth-required)/(fragments)/fragment": [48,[2],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/configure": [50,[2,,4,5],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/configure/builder": [51,[2,,4,5],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/configure/frame": [52,[2,,4,5],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/configure/json": [53,[2,,4,5],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/history": [57,[2,,4],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/history": [54,[2,,4],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/json": [55,[2,,4],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/versions": [58,[2,,4],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]/versions": [56,[2,,4],[,3]],
		"/(auth-required)/(fragments)/fragment/[fragment_id]/[[version]]": [49,[2,,4],[,3]],
		"/(auth-required)/inline-modules/[org_namespace_or_id]/[module_name]/[[version]]": [89,[2,21]],
		"/(auth-required)/internal": [90,[2,22]],
		"/(auth-required)/internal/ai-assistant-stats": [91,[2,22,23]],
		"/(auth-required)/internal/feature-flags-admin": [92,[2,22,24]],
		"/(auth-required)/internal/ops-billing-dashboard": [93,[2,22,25]],
		"/(auth-required)/internal/org-admin": [94,[2,22,26]],
		"/(auth-required)/internal/registry-admin": [95,[2,22,27]],
		"/(auth-required)/internal/registry-admin/usage": [96,[2,22,27]],
		"/(auth-required)/internal/release-admin": [97,[2,22,28]],
		"/(auth-required)/login-method-denied": [98,[2,29]],
		"/(auth-required)/machine/[machine_id]": [99,[2,30]],
		"/(auth-required)/machine/[machine_id]/3d-scene/[[part_id]]": [100,[2,30]],
		"/(auth-required)/machine/[machine_id]/configure": [101,[2,30]],
		"/(auth-required)/machine/[machine_id]/configure/builder": [102,[2,30]],
		"/(auth-required)/machine/[machine_id]/configure/json/[[part_id]]": [103,[2,30]],
		"/(auth-required)/machine/[machine_id]/connect": [104,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/connect/api-keys": [105,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/connect/cli/[[part_id]]": [106,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample": [107,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/browser": [108,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/cpp": [109,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/flutter": [110,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/golang": [111,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/node": [112,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/code-sample/python": [113,[2,30,31,32]],
		"/(auth-required)/machine/[machine_id]/connect/configure-remote-part/[[part_id]]": [114,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/connect/shell-command/[[part_id]]": [116,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/connect/shell/[[part_id]]": [115,[2,30,31]],
		"/(auth-required)/machine/[machine_id]/control/[[part_id]]": [117,[2,30]],
		"/(auth-required)/machine/[machine_id]/debug-configuration/[part_id]": [118,[2,30,33]],
		"/(auth-required)/machine/[machine_id]/history/[[part_id]]": [119,[2,30]],
		"/(auth-required)/machine/[machine_id]/logs/[[part_id]]": [120,[2,30,34]],
		"/(auth-required)/machine/[machine_id]/motion/[[part_id]]": [121,[2,30]],
		"/(auth-required)/machine/[machine_id]/setup/[[part_id]]": [122,[2,30,35]],
		"/magicsetup/[token]": [142],
		"/(registry-item-detail)/ml-model/[org_namespace_or_id]/[model_name]": [138,[47]],
		"/(registry-item-detail)/ml-training/[org_namespace_or_id]/[item_name]": [139,[47]],
		"/(auth-required)/models": [123,[2,36]],
		"/(auth-required)/models/upload": [126,[2,36]],
		"/(auth-required)/models/[registry_item_name]": [124,[2,36,37]],
		"/(auth-required)/models/[registry_item_name]/[job_id]": [125,[2,36,37]],
		"/(registry-item-detail)/module/[org_namespace_or_id]/[module_name]": [140,[47]],
		"/namespace/[public_namespace]": [143],
		"/(auth-required)/org-not-accessible": [127,[2,38]],
		"/(auth-required)/organization/[org_id]/(settings)/api-keys": [128,[2,39,40]],
		"/(auth-required)/organization/[org_id]/(settings)/billing": [129,[2,39,40]],
		"/(auth-required)/organization/[org_id]/(settings)/default-fragments": [130,[2,39,40]],
		"/(auth-required)/organization/[org_id]/(settings)/members": [131,[2,39,40]],
		"/(auth-required)/organization/[org_id]/payment": [133,[2,39]],
		"/(auth-required)/organization/[org_id]/(settings)/settings": [132,[2,39,40]],
		"/(auth-required)/query-access": [134,[2,41]],
		"/registry": [144],
		"/(auth-required)/teleop": [135,[2,42],[,43]],
		"/(auth-required)/teleop/[workspace_id]/[[page=teleopmachine]]/[[machine_id]]": [136,[2,42,44,45],[,43]],
		"/(auth-required)/user/(settings)/settings": [137,[2,46]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';